module.exports = __webpack_public_path__ + "img/9788959526222.c51f36a1.jpg";